export enum AuthenticationAnalyticsEvents {
  // Reliability signals (observability RFC): auth/login success rate.
  LoginSucceeded = 'login_succeeded',
  LoginFailed = 'login_failed',
  TokenRefreshed = 'token_refreshed',
  TokenRefreshFailed = 'token_refresh_failed',
  ExtensionBackButtonPressed = 'ext_back_btn_pressed',
  LogoutSuccess = 'logout_success',
  PbxSelected = 'pbx_selected',
  PbxSwitched = 'pbx_switched',
  CallSupportClicked = 'call_support_clckd',
  EmailSupportClicked = 'email_support_clckd',
  ForgotPasswordClicked = 'forgot_password_clckd',
  PasswordResetRequested = 'password_reset_requested',
  PasswordResetCompleted = 'password_reset_completed',
  PasswordResetFailed = 'password_reset_failed',
}
